import { DateOnly } from '@if/core/date'
import { EFinancingCompany, EFinancingProgram, EMerchantType, MerchantBase } from '@if/core/types'
import { MerchantPaymentPlan } from './MerchantPaymentPlan'

export enum EReportGenerationFrequency {
  None = 'none',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

/**
 * A negotiated rate for applicants at or above `minErs`. An agreement overrides the
 * norms rate, the iFinance promotion and the merchant rate modifier.
 */
export interface RateAgreementRange {
  minErs: number
  rate: number
  financingProgramId: EFinancingProgram
  lenderFeeRate: number
  adminFeeMerchant: number
}

export interface Merchant extends MerchantBase {
  /** Absent for most merchants — only those with a negotiated rate. */
  rateAgreements?: RateAgreementRange[]
  merchantTypeId: EMerchantType
  paymentPlans: MerchantPaymentPlan[]
  financingCompanyId: EFinancingCompany
  canSkipFlinks: boolean
  insuranceProviderIds: string[]
  warrantyProviderIds: string[]
  firstOnboardedOn: DateOnly
  showInterestRateOnMerchantDashboard: boolean
  reportGenerationFrequency: EReportGenerationFrequency
  reportRecipientsEmailList: string[]
  bannerOwnedFields: string[]
  flashPlanDefinedInManageMerchant: boolean
  allowCoApplicant: boolean
}
